module.exports = __webpack_public_path__ + "img/category_wellness.63d4c0e.png";